import { createBaseApi } from '@/api/baseApi'

const PACKING_URL = 'order/packages'

export default {
  ...createBaseApi(PACKING_URL)
}
